import { convenienceFeeAmount as calcConvenienceFee } from "helper/convenienceFee";

export const calculateTotals = (
  data,
  paymentType,
  applyConvenienceFee = true,
) => {
  // Get payment methods from localStorage
  const creditCardMethod = JSON.parse(
    localStorage.getItem("paymentMethodCreditCard"),
  );
  const achPaymentMethod = JSON.parse(localStorage.getItem("paymentMethodAch"));

  const currentPaymentMethod =
    paymentType === "credit-card"
      ? creditCardMethod
      : paymentType === "ach"
      ? achPaymentMethod
      : null;

  const prices = data?.formPricing?.prices ?? [];

  let totalAmount = 0;
  let totalDueAmount = 0;
  let nonInstallmentAmount = 0;
  let hasInstallment = false;

  const pricesWithInstallmentInfo = prices.map((item) => {
    totalAmount += item.amount;

    let individualDue = null;

    if (item.isInstallmentTransaction && item.installment?.value) {
      hasInstallment = true;
      individualDue = item.amount / item.installment.value;
      totalDueAmount += individualDue;
    } else {
      nonInstallmentAmount += item.amount;
    }

    return {
      ...item,
      individualDue,
    };
  });

  const newDue = hasInstallment ? totalDueAmount + nonInstallmentAmount : 0;

  // Determine base amount for convenience fee calculation
  const baseForConvenienceFee = newDue > 0 ? newDue : totalAmount;
  const shouldApplyConvenienceFee =
    currentPaymentMethod?.coverConvenienceFee && applyConvenienceFee;

  const convenienceFee = shouldApplyConvenienceFee
    ? calcConvenienceFee(
        currentPaymentMethod.convenienceFeeInfo,
        baseForConvenienceFee,
      )
    : 0;

  const finalAmount =
    newDue > 0 ? newDue + convenienceFee : totalAmount + convenienceFee;

  const balanceToPay = totalAmount - newDue;

  const totalWithConvenienceFee = totalAmount + convenienceFee;
  const dueWithConvenienceFee = newDue !== 0 ? newDue + convenienceFee : totalWithConvenienceFee;

  return {
    totalAmount,
    totalDueAmount: hasInstallment ? totalDueAmount : 0,
    nonInstallmentAmount,
    newDue,
    convenienceFee,
    finalAmount,
    balanceToPay,
    pricesWithInstallmentInfo,
    dueWithConvenienceFee,
    totalWithConvenienceFee,
  };
};
